import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import Utils from 'js/shared/utils';
// Component
import Modal from 'js/shared-order/components/Modal';
import ButtonCustom from 'js/shared-order/components/Button';
import ModalSelectMenuImage from 'js/shop-order/components/setting/ModalSelectMenuImage';
import ModalAddMenuChip from './ModalAddMenuChip';
import Dialog from 'js/shared-order/components/Dialog';

import ShopOrderApiService from 'js/shop-order/shop-order-api-service';
import ShopInfoContext from 'js/shop/components/ShopInfoContext';

// Components(Material-UI)
import { Box, OutlinedInput, Grid, TextareaAutosize } from '@material-ui/core';

// Utils
import { checkValidation } from './validationStaff';
import { renderUrlImageS3 } from 'js/utils/helpers/image';
import { DEFAULT_AVATAR_URL } from 'js/utils/helpers/const';

// Styles
import { userStylesPageStaff as useStyles } from './styles';

const MAX_CHIP_MENUS = 3;

const DEFAULT_STAFF = {
  hash_id: null,
  given_name: '',
  image_path: '',
  description: '',
  m_chip_menus: [],
  delete_m_chip_menus: [],
  add_m_chip_menus: [],
  all_chip_menus: [],
  update_m_chip_menus: [],
};

const ModalAddStaff = (props) => {
  const classes = useStyles();

  // Context
  const [shop] = useContext(ShopInfoContext);

  // Local state
  const [staffInfo, setStaffInfo] = useState(DEFAULT_STAFF);
  const [inProgress, setInProgress] = useState(false);
  const [showModalSelectImage, setShowModalSelectImage] = useState(false);
  const [showModalThankItem, setShowModalThankItem] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [indexImageClicked, setIndexImageClicked] = useState(null);
  const [chipMenus, setChipMenus] = useState([]);

  useEffect(() => {
    const { open, staff } = props;
    if (open) {
      let staffInfoClone = {};
      if (staff) {
        staffInfoClone = Utils.cloneDeep(staff);
        staffInfoClone.all_chip_menus = [...staff?.m_chip_menus];
        staffInfoClone.add_m_chip_menus = [];
        staffInfoClone.delete_m_chip_menus = [];
      } else {
        staffInfoClone = Utils.cloneDeep(DEFAULT_STAFF);
      }
      setStaffInfo(staffInfoClone);
      getListChipMenus();
    }
  }, [props.open]);

  const getListChipMenus = async () => {
    try {
      const chipMenuResult = await ShopOrderApiService.getChipMenusForStaff(shop.hashId);
      setChipMenus(chipMenuResult);
    } catch (error) {
      showWarningMessage(error.message);
    }
  }

  const inputChanged = (event) => {
    const newStaff = Utils.cloneDeep(staffInfo);
    const { name, value } = event.target;
    newStaff[name] = value;
    setStaffInfo(newStaff);
  };

  const setMenuFiles = (file) => {
    const staffInfoClone = Utils.cloneDeep(staffInfo);
    if (file) {
      staffInfoClone.image_path = file;
    }
    setStaffInfo(staffInfoClone);
  };

  const handleSubmit = async () => {
    const { showWarningMessage, showSuccessMessage, getStaffs, currentPage, onClose } = props;
    const errors = checkValidation(staffInfo);
    setInProgress(true);

    if (errors.length > 0) {
      showWarningMessage(errors[0]);
      setInProgress(false);

      return;
    }

    try {
      if (staffInfo && staffInfo.hash_id) {
        await ShopOrderApiService.updateStaff(shop.hashId, staffInfo.hash_id, {...staffInfo});

        showSuccessMessage('更新しました。');
      } else {
        await ShopOrderApiService.createStaff(shop.hashId, {...staffInfo});

        showSuccessMessage('作成しました。');
      }
      getStaffs({ page: currentPage });
      setInProgress(false);
      onClose();
      setStaffInfo(DEFAULT_STAFF);
    } catch (error) {
      setInProgress(false);
      showWarningMessage(error.message);
    }
  };

  const deleteMenuChip = () => {
    const staffInfoClone = Utils.cloneDeep(staffInfo);
    const chipMenuDeleted = staffInfoClone?.all_chip_menus.splice(indexImageClicked, 1);
    const indexImageInChipMenus = staffInfoClone?.m_chip_menus
      ?.map((chipMenu) => chipMenu.id)
      ?.indexOf(chipMenuDeleted[0].id);
    const indexImageInAddChipMenus = staffInfoClone?.add_m_chip_menus?.indexOf(
      chipMenuDeleted[0].id
    );

    if (indexImageInChipMenus !== -1) {
      // Case: chip menu deleted belong to m_chip_menus
      staffInfoClone?.delete_m_chip_menus.push(chipMenuDeleted[0].id);
      setChipMenus([...chipMenus, chipMenuDeleted[0]]);
    } else {
      setChipMenus([...chipMenus, chipMenuDeleted[0]]);
    }

    if (indexImageInAddChipMenus !== -1) {
      // Case: chip menu deleted dont belong to m_chip_menus => remove chip menu in add_m_chip_menus
      staffInfoClone?.add_m_chip_menus.splice(indexImageInAddChipMenus, 1);
    }
    setStaffInfo(staffInfoClone);
  };

  const actionModal = () => (
    <Box textAlign='center'>
      <ButtonCustom
        title='戻る'
        borderRadius='28px'
        bgcolor='#828282'
        borderColor='#828282'
        width='176px'
        onClick={() => {
          props.onClose();
          setStaffInfo(DEFAULT_STAFF);
        }}
      />
      <ButtonCustom
        title='保存'
        borderRadius='28px'
        bgcolor='#FFA04B'
        borderColor='#FFA04B'
        width='176px'
        disabled={inProgress}
        onClick={handleSubmit}
      />
    </Box>
  );

  return (
    <Modal actions={actionModal()} open={props.open} title='スタッフ設定' minHeight='375px' customClass={classes.cardContentStaff}>
      <Box className={classes.contentDetail} ml={2} mr={3} mt={4}>
        <Grid container spacing={2}>
          <Grid item md={8} sm={12}>
            <Grid container spacing={2}>
              <Grid item sm={1} xs={12}></Grid>
              <Grid item sm={3} xs={12}>
                なまえ
              </Grid>
              <Grid item sm={8} xs={12}>
                <OutlinedInput
                  id='given_name'
                  name='given_name'
                  value={staffInfo.given_name}
                  className={classes.inputModalStaff}
                  labelWidth={0}
                  onChange={inputChanged}
                />
              </Grid>
            </Grid>

            <Grid container spacing={2}>
              <Grid item sm={1} xs={12}></Grid>
              <Grid item sm={3} xs={12}>
                一言
              </Grid>
              <Grid item sm={8} xs={12}>
                <TextareaAutosize
                  maxRows={4}
                  id='description'
                  name='description'
                  value={staffInfo.description}
                  className={`${classes.inputModalStaff} ${classes.textArea}`}
                  labelWidth={0}
                  variant='outlined'
                  onChange={inputChanged}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item md={4} xs={12}>
            <Box display='flex' justifyContent='center'>
              <img
                id='file'
                name='file'
                className={classes.avatarModalStaff}
                src={
                  staffInfo.image_path
                    ? `${renderUrlImageS3(staffInfo.image_path)}`
                    : `${process.env.MIX_ASSETS_PATH}/${DEFAULT_AVATAR_URL}`
                }
                onClick={() => setShowModalSelectImage(true)}
              />
            </Box>
          </Grid>
        </Grid>

        <Grid container spacing={2} className={classes.wrapperChipMenu}>
          <Grid item sm={3} xs={12} className={classes.textCenter}>
            応援アイテム
          </Grid>
          <Grid item sm={9} xs={12} className={classes.wrapMenuChip}>
            <Box display='flex' className={classes.scrollContent}>
              {staffInfo?.all_chip_menus?.map((chipMenu, key) => {
                return (
                  <Box key={key} mr={3} width={80}>
                    <Box position='relative' mb={2}>
                      <img style={{ minWidth: '80px' }} src={renderUrlImageS3(chipMenu.main_image_path)} />
                      <Box
                        className={classes.deleteMenuChip}
                        onClick={() => {
                          setShowDialog(true);
                          setIndexImageClicked(key);
                        }}
                      >
                        x
                      </Box>
                    </Box>
                    <Box className={classes.priceItem}>{chipMenu.price}</Box>
                  </Box>
                );
              })}
              <ButtonCustom
                borderRadius='4px'
                variant='outlined'
                borderColor='#FFA04B'
                width='100px'
                margin='0'
                padding='33px 0'
                bgcolor='#FFF'
                fgcolor='#FFA04B'
                customClass={classes.addChipMenuButton}
                onClick={() => setShowModalThankItem(true)}
                disabled={staffInfo?.all_chip_menus?.length >= MAX_CHIP_MENUS}
              >
                +追加
              </ButtonCustom>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <ModalSelectMenuImage
        open={showModalSelectImage}
        onClose={() => setShowModalSelectImage(false)}
        setMenuFiles={setMenuFiles}
      />
      <ModalAddMenuChip
        open={showModalThankItem}
        onClose={() => setShowModalThankItem(false)}
        staffInfo={staffInfo}
        setStaffInfo={setStaffInfo}
        chipMenus={chipMenus}
        setChipMenus={setChipMenus}
      />
      <Dialog
        isOpen={showDialog}
        onClose={(isOpen) => setShowDialog(isOpen)}
        title='削除'
        message='このアイテムを削除しますか？'
        onConfirm={deleteMenuChip}
      />
    </Modal>
  );
};

// PropTypes
ModalAddStaff.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  staff: PropTypes.object,
  currentPage: PropTypes.number,
  getStaffs: PropTypes.func,
  showWarningMessage: PropTypes.func,
  showSuccessMessage: PropTypes.func,
};

// defaultProps
ModalAddStaff.defaultProps = {
  open: false,
  onClose: () => {},
  staff: null,
  currentPage: 0,
  getStaffs: () => {},
  showWarningMessage: () => {},
  showSuccessMessage: () => {},
};

export default ModalAddStaff;
